/* global dataLayer */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import { useRouter } from 'next/router';
import RadioButton from 'Components/RadioButton';
import Fieldset from 'Components/Fieldset';
import ButtonNext from 'Components/ButtonNext';
import updateAction from 'utils/updateAction';
import getPaymentMethod from 'utils/getPaymentMethod';
import s from './Step3.module.scss';

const Step3 = ({ formNamespace, paymentMethods = [] }) => {
    const router = useRouter();
    const updateName = (state, payload) => {
        return updateAction(state, payload, formNamespace);
    };
    const { state, actions } = useStateMachine({ updateName });
    const { register, handleSubmit, watch, formState, trigger } = useForm({
        mode: 'onChange',
        defaultValues: state[formNamespace],
    });

    const onSubmit = (data) => {
        const paymentLabel = getPaymentMethod(data.payment);

        dataLayer.push({
            event: 'checkoutSteps',
            eventCategory: 'företagsgåva',
            eventAction: 'betalsatt',
            eventLabel: paymentLabel,
        });

        Object.assign(data, { steg3: true });
        actions.updateName(data);
        router.push({hash: 'summering'});
    };

    watch(['payment']);

    useEffect(() => {
        trigger('payment');
    }, []);

    const { isValid } = formState;

    return (
        <form className={s['Step3']} onSubmit={handleSubmit(onSubmit)}>
            <Fieldset>
                {paymentMethods.includes('payex_psp_swish') && (
                    <div className={s['Step3__Payment']}>
                        <RadioButton
                            id="swish"
                            label="Swish"
                            name="payment"
                            register={register('payment')}
                            value="payex_psp_swish"
                            checked={paymentMethods[0] === 'payex_psp_swish'}
                        />
                        <div className={s['Step3__PaymentInfo']}>
                            <p className={s['Step3__SwedPay']}>I samarbete med</p>
                        </div>
                    </div>
                )}
                {paymentMethods.includes('payex_psp_cc') && (
                    <div className={s['Step3__Payment']}>
                        <RadioButton
                            id="card"
                            label="Direktbetalning med kort"
                            name="payment"
                            register={register('payment')}
                            value="payex_psp_cc"
                            checked={paymentMethods[0] === 'payex_psp_cc'}
                        />
                        <div className={s['Step3__PaymentInfo']}>
                            <p className={s['Step3__SwedPay']}>I samarbete med</p>
                        </div>
                    </div>
                )}
                {paymentMethods.includes('cod') && (
                    <div className={s['Step3__Payment']}>
                        <RadioButton
                            id="cod"
                            label="Inbetalningskort"
                            name="payment"
                            register={register('payment')}
                            value="cod"
                            checked={paymentMethods[0] === 'cod'}
                        />
                    </div>
                )}
            </Fieldset>
            <ButtonNext disabled={!isValid}>Granska</ButtonNext>
        </form>
    );
};

Step3.propTypes = {
    formNamespace: PropTypes.string,
    paymentMethods: PropTypes.array,
};

export default Step3;
